import React from 'react';
import {
  OutlinedInput
  , InputAdornment
  , FormHelperText
  , FormControl
} from '@material-ui/core';

import ErrorIcon from '@material-ui/icons/Error';
import useStyles from '../styles/styles';


type PeInputProps = {
  readonly input?: any,
  readonly type: string,
  readonly placeholder?: string,
  readonly id: string,
  readonly label: string,
  readonly isShowLabel?: boolean,
  readonly adornment?: string,
  readonly required?: boolean,
  readonly disabled?: boolean,
  readonly meta?: {
    touched: any,
    error: any
  }
};

const PeInput: React.FC<PeInputProps> = ({ isShowLabel, id, input, required, label, type, placeholder, adornment, meta, disabled }) => {
  const classes = useStyles();

  const showLabel = typeof isShowLabel !== 'undefined' ? Boolean(isShowLabel) : true;

  const createMask = (str: string) => {
    return str.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3");
  }

  const destroyMask = (str: string) => {
    return str.replace(/\D/g, '').substring(0, 10);
  }

  const getMaskValue = () => {
    if (id !== "phone_number") {
      return input.value;
    } else {
      return createMask(destroyMask(input.value));
    }
  }

  return <FormControl error={Boolean(meta?.error)} variant="outlined" fullWidth>
    {showLabel && <h3 className={classes.label}>{required && <span className={classes.required}>*</span>}&nbsp;{label}</h3>}
    <OutlinedInput className={classes.input}
      inputProps={{ ...input, maxLength: type === "tel" ? 12 : null, value: getMaskValue() }}
      id={id}
      placeholder={placeholder}
      type={type}
      startAdornment={adornment && <InputAdornment position="start" >{adornment}</InputAdornment>}
      disabled={disabled}
    // value={getMaskValue()}
    // {...props.input}
    />
    {/* {props.type === "tel" && getMaskValue()} */}
    {meta?.error && <FormHelperText className={classes.helpText} component="div">
      <ErrorIcon fontSize="small" />
      <p style={{ margin: 0, padding: 0 }}>&nbsp;{meta?.error}</p>
    </FormHelperText>}
  </FormControl>
}

export default PeInput;